import React from "react";
import "./experience-card.css";
function ExperienceCard({ item }) {
  return (
    <div className="experience-card">
      <div className="experience-info">
        <div className="experience-header">
          <div className="experience-title-section">
            <label className="company-designation">{item.designation}</label>
            <div className="company-name">
              <label>{item.company}</label>
            </div>
          </div>
          <div className="experience-meta">
            <span className="experience-duration">{item.dateJoining} - {item.dateEnd}</span>
          </div>
        </div>
        <div className="experience-desc">
          <h4>Key Contributions:</h4>
          <ul>
            {item.work.map((exp, index) => {
              return <li key={index} dangerouslySetInnerHTML={{ __html: exp }}></li>;
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ExperienceCard;
